const { post } = require("network/http/api")

export const addNotificationWebToken = (token) => {
  return post(`/notification/token/web`, { token: token })
}